import { Tab, Tabs, Box } from "@mui/material";
import { toStdDate } from "../../utils/dates";

const VenueTabs = ({dayEvents, selectedVenueTab, handleTabChange}) => {

  console.log("DEBUG: VenueTabs.jsx: VenueTabs: dayEvents: ", dayEvents)

    return (
      <Tabs
        variant="scrollable"
        scrollButtons="auto"
        value={selectedVenueTab}
        onChange={handleTabChange}
        textColor="inherit"
        indicatorColor="primary"
        TabIndicatorProps={{ sx: { display: "none" } }}
        sx={{
          margin: "0 0 1em 0",
          ".Mui-selected": {
            color: `var(--orange)`,
            fontWeight: "700",
          },
          "& .MuiTabs-flexContainer": {
            flexWrap: "wrap",
          },
        }}
      >

        {dayEvents?.map((v, i) => {

          const originalLabel =
            v?.event?.name.substring(0, 20) +
            "@" +
            v?.event?.venue?.name?.substring(0, 20) +
            " ";

          const scrollLabel =
            v?.event?.name +
            "@" +
            v?.event?.venue?.name +
            " ";

          return (
            <Tab
              label={
                <Box sx={{position: "relative", width: "360px"}}>
                  <span className="short-label">{originalLabel}</span>
                  <div className="full-label">
                    <span className="scroll-label">
                      <span style={{margin:"0 2.5em 0 2.5em"}}>{scrollLabel}</span>
                      <span>{scrollLabel}</span>
                    </span>
                  </div>
                  <span>{toStdDate(v?.event?.date)}</span>
                </Box>
              } 
              key={`venuetab-${i}`}
              value={v.bteId}
            />
          );

        })}

        <style>
          {`
            .short-label {
              display: block;
            }

            .MuiTab-root:hover .short-label {
              display: none;
            }

            .scroll-label {
              display: inline-block;
              white-space: nowrap;
            }

            .MuiTab-root:hover .scroll-label {
              animation: scroll-label 4s linear infinite;
            }

            .full-label {
              display: none;
            }
            
            .MuiTab-root:hover .full-label {
              display: block;
            }

            @keyframes scroll-label {
              0% { transform: translateX(0%); }
              100% { transform: translateX(-50%); }
            }
          `}
        </style>

      </Tabs>
    );
  };

export default VenueTabs;